import React, {Dispatch, SetStateAction} from 'react';
import {Dialog, DialogBody, DialogFooter, DialogHeader, IconButton, Spinner} from "@material-tailwind/react";
import {Close} from "@mui/icons-material";
import {size} from "../../services/types/types";

export type Props = {
    loading?: boolean;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    size?: size;
    title?: string;
    body?: React.ReactNode;
    footer?: React.ReactNode;
}

export default function CustomDialog({
                                         loading,
                                         open,
                                         setOpen,
                                         size,
                                         title,
                                         body,
                                         footer
                                     }: Props) {
    const closeDialog = () => {
        setOpen!(!open)
    }

    return (
        <Dialog placeholder="dialog"
                className='max-h-[80%] sm:max-h-[90%] overflow-y-auto overflow-x-hidden min-w-[247.5px] rounded-[15px] bg-transparent z-1501'
                open={open}
                handler={() => {}}
                size={size ? size :'xl'}
        >
            <DialogHeader placeholder="dialog-header"  className={'bg-header px-4 py-1'}>
                <div className={'flex flex-row w-full items-center'}>
                    {loading && <Spinner/>}
                    <h3 className={'text-white'}>{title}</h3>
                    <div className={'ml-auto'}>
                        <IconButton placeholder="icon-button"  variant="text" color="gray"
                                    onClick={() => {
                                        closeDialog()
                                    }}>
                            {
                                <Close className="w-5 text-white" />
                            }
                        </IconButton>
                    </div>
                </div>
            </DialogHeader>
            <DialogBody placeholder="dialog-body"  className={'px-6 flex flex-col gap-2 bg-white'} divider>
                {body}
            </DialogBody>
            {footer &&
                <DialogFooter placeholder="dialog-footer">{footer}</DialogFooter>
            }
        </Dialog>
    );
}
